/** A stat is a rate when its headline or unit carries a percent sign; rates change in points. */
export const isRateStat = (headline, unit) => headline.endsWith('%') || !!unit?.trim().startsWith('%');
/** Change between the last two trend values: percentage points for rates, relative change otherwise. */
export const describeStatChange = (values, isRate) => {
    if (values.length < 2)
        return null;
    const [previous, latest] = values.slice(-2);
    if (previous === undefined || latest === undefined)
        return null;
    if (!isRate && previous === 0)
        return null;
    const delta = isRate ? latest - previous : ((latest - previous) / Math.abs(previous)) * 100;
    const rounded = Math.round(delta * 10) / 10;
    const size = Math.abs(rounded);
    return { isUp: rounded >= 0, label: isRate ? `${size} ${size === 1 ? 'pt' : 'pts'}` : `${size}%` };
};
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;
const shortDate = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
/** Trend axis labels: ISO dates read as "Sep 1", anything else as-is. */
export const formatStatTrendLabel = (value) => {
    const match = ISO_DATE.exec(value);
    if (!match)
        return value;
    const [, year, month, day] = match;
    return shortDate.format(new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))));
};
//# sourceMappingURL=stat-tile.js.map